<h3 mat-dialog-title class="text-center mt-3">{{ data?.title }}</h3>
<mat-dialog-content>
  <button [mat-dialog-close]="true" mat-button class="close-icon">
    <mat-icon>close</mat-icon>
  </button>
  <mat-nav-list class="pl-4 pr-4">
    <mat-list-item *ngFor="let item of data.data">
      <span mat-line>{{ item.name }}</span>
      <span *ngIf="!isArray(item.value)" mat-matListAvatar class="title-page">{{ item.value }}</span>
      <div *ngIf="isArray(item.value)" mat-matListAvatar class="title-page" [innerHTML]="parseText(item.value)"></div>
      <mat-divider></mat-divider>
    </mat-list-item>
  </mat-nav-list>
</mat-dialog-content>
